import React from 'react';
import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';
import './index.css';
import App from './App';
import { initMixpanel } from './utils/tracking/mixpanel';

TagManager.initialize({ gtmId: 'GTM-PRWJP9K' });
initMixpanel();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
